var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgContact = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CONTACT US"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.6665 6.66667H15.8332M12.4998 10H15.8332M14.1665 13.3333H15.8332M14.1665 17.5H5.83317C2.49984 17.5 1.6665 16.6667 1.6665 13.3333V6.66667C1.6665 3.33333 2.49984 2.5 5.83317 2.5H14.1665C17.4998 2.5 18.3332 3.33333 18.3332 6.66667V13.3333C18.3332 16.6667 17.4998 17.5 14.1665 17.5Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.99984 13.6083C9.94375 13.0233 9.68473 12.4764 9.26768 12.0624C8.85064 11.6484 8.30186 11.3934 7.7165 11.3416C7.29531 11.2999 6.87103 11.2999 6.44984 11.3416C5.86505 11.395 5.31716 11.6505 4.90041 12.0642C4.48367 12.4779 4.22415 13.0239 4.1665 13.6083M7.08317 9.40827C7.48321 9.40827 7.86686 9.24935 8.14972 8.96649C8.43259 8.68362 8.5915 8.29997 8.5915 7.89993C8.5915 7.4999 8.43259 7.11625 8.14972 6.83338C7.86686 6.55052 7.48321 6.3916 7.08317 6.3916C6.68314 6.3916 6.29949 6.55052 6.01662 6.83338C5.73375 7.11625 5.57484 7.4999 5.57484 7.89993C5.57484 8.29997 5.73375 8.68362 6.01662 8.96649C6.29949 9.24935 6.68314 9.40827 7.08317 9.40827Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgContact, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/contact.0488677e.svg";
export { ForwardRef as ReactComponent };